import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import "./BikeRequest.css";
import Form from 'react-bootstrap/Form';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";

import bikeOnHill from "../../Assets/bikeonhill.jpg"

type BikeRequestFormInputs = {
  make: string;
  model: string;
  year: string;
  email: string;
};

const validation = Yup.object().shape({
  make: Yup.string().required("Make is required"),
  model: Yup.string().required("Model is required"),
  year: Yup.string().required("Year is required"),
  email: Yup.string().required("Email is required")
});

interface Props {
  request: (make: string, model: string, year: string, email: string) => void;
}

const BikeRequest = ({request}: Props) => {
    const {
      register,
      handleSubmit,
      formState: { errors },
    } = useForm<BikeRequestFormInputs>({ resolver: yupResolver(validation) });
  
    const handleBikeRequest = (form: BikeRequestFormInputs) => {
      request(form.make, form.model, form.year, form.email);
    };

  return (
    <section className="bike-request">
      <Container className="shadow rounded bg-white">
        <Row className="justify-content-md-center">
          <div className="container text-center mt-4">
            <h1 className="mb-4">Bike request</h1>
            <p className="mb-4">Looking for a specific bike? Submit a requset for your specks here!</p>
            <form onSubmit={handleSubmit(handleBikeRequest)}>
              <div className="row justify-content-center">
              <div className="col-md-5 text-left">
                <img
              src={ bikeOnHill } className="bike-image p-0 img-fluid rounded"
              alt="Bike image"
            />
              </div>
              <div className="col-md-5 text-left">
              <div className="row justify-content-center">
                <div className="col-md-10 text-left">
                  <label className="form-label d-block text-start">Make</label>
                  <Form.Control id="make" type="text" placeholder="Make" {...register("make")}/>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-10">
                  <Form.Label className="form-label d-block text-start">Model</Form.Label>
                  <Form.Control id="model" type="text" placeholder="Model" {...register("model")}/>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-10">
                  <Form.Label className="form-label d-block text-start">Year</Form.Label>
                  <Form.Control id="year" type="text" placeholder="Year" {...register("year")}/>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-10">
                  <Form.Label className="form-label d-block text-start">Email</Form.Label>
                  <Form.Control id="email" type="email" placeholder="email@example.com" {...register("email")}/>
                </div>
              </div>
              <div className="row justify-content-center mt-3">
                <div className="col-md-9">
                  <Button type="submit" className="btn btn-primary w-100 mt-4 mb-4">Submit</Button>
                </div>
              </div>
              </div>
              </div>
            </form>
          </div>
        </Row>
      </Container>
    </section>
  );
};

export default BikeRequest;
